// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1hAlU","paramInput":"JobSimulator_paramInput__lvXXr","input":"JobSimulator_input__1Y2c7"};